import {FormControl, FormGroup} from "@angular/forms";
import {DeviceBase} from "./device-base";
import {PropertyMetadata} from "../../properties/property-types";
import {RegisterElement} from "../element-decorator";

@RegisterElement()
export class Controller extends DeviceBase {
    protected sizeInMeters: number = 1;
    public override TypeName: string = "Controller";
    public override ParentType: string | null = "ParkingLevel";
    public override ParentFormGroupName: string | null = "Controllers";

    constructor(formGroup: FormGroup) {
        super(formGroup, 'assets/icons/controller.svg');

        if (!formGroup.contains('RelayIpAddress')) {
            formGroup.addControl('RelayIpAddress', new FormControl(''));
        }
        if (!formGroup.contains('RelayPort')) {
            formGroup.addControl('RelayPort', new FormControl(0));
        }
        if (!formGroup.contains('LogToken')) {
            formGroup.addControl('LogToken', new FormControl(''));
        }
        if (!formGroup.contains('SoftwareVersionId')) {
            formGroup.addControl('SoftwareVersionId', new FormControl(''));
        }
        if (!formGroup.contains('RelayType')) {
            formGroup.addControl('RelayType', new FormControl(''));
        }
        if (!formGroup.contains('LocalAddress')) {
            formGroup.addControl('LocalAddress', new FormControl(''));
        }
        if (!formGroup.contains('KioskControllerBoardSettings')) {
          formGroup.addControl('KioskControllerBoardSettings', new FormControl(''));
        }
    }

    public override getPropertyMetadata(): PropertyMetadata[] {
        return [
            ...super.getPropertyMetadata(),
            {
                formControlName: 'KioskControllerBoardSettings',
                displayName: 'Kiosk Controller Settings',
                inputType: { type: 'text' },
                order: 13,
                category: 'Network'
            },
            {
                formControlName: 'RelayType',
                displayName: 'Power Relay Type',
                inputType: {
                    type: 'select',
                    options: [
                        { value: '', label: '' },
                        { value: 'tcp-kp-1202', label: '1202 Relay' }
                    ]
                },
                order: 12,
                category: 'Diagnostic/Debug'
            },
            {
                formControlName: 'LocalAddress',
                displayName: 'IP Address',
                inputType: { type: 'text' },
                order: 6,
                category: 'Network'
            },
            {
                formControlName: 'RelayIpAddress',
                displayName: 'Relay IP Address',
                inputType: { type: 'text' },
                order: 7,
                category: 'Diagnostic/Debug'
            },
            {
                formControlName: 'RelayPort',
                displayName: 'Relay Port',
                inputType: {
                    type: 'number',
                    min: 0
                },
                order: 8,
                category: 'Diagnostic/Debug'
            },
            {
                formControlName: 'LogToken',
                displayName: 'Log Token',
                inputType: {
                    type: 'text',
                },
                order: 9,
                category: 'Diagnostic/Debug'
            },

        ];
    }

    public override clone(): Controller {
        return new Controller(this.formGroup);
    }

    public override default(): Controller {
        return this;
    }
}
